module.exports = __webpack_public_path__ + "img/close-square.48d530df.svg";